/* globals cpac, $j */

if (typeof cpac !== 'undefined') {
  cpac.programPaymentPlan = {
    parts : 0,
    percentageName: 'payment_plan_percent',
    dollarName: 'payment_plan_dollar',
    activeDollarType: 0,
    addPlan: function() {
        this.parts++;
        var element = '';
        element += '<div class="payment_plan_'+this.parts+'" style="overflow: hidden; padding: 5px 0;">';
            element += '<div class="label"  style="font-size: 11px;">Payment '+this.parts+':</div><br/>';
            element += '<input id="params-payment_plan_percent-'+this.parts+'" class="field" type="text" onblur=" Element.removeClassName(this, \'active-input\');" onfocus=" Element.addClassName(this, \'active-input\');" style="width: 55px; float: left;" maxlength="8" value="" name="' + this.getPlanInputName(this.parts) + '">';
            element += '<div class="payment_plan_type">' + this.getPlanTypeLabel() + '</div>';
            element += '<input id="params-payment_plan-'+this.parts+'" class="field" type="text" style="width: 75px; float: none;" onblur=" Element.removeClassName(this, \'active-input\');" onfocus=" Element.addClassName(this, \'active-input\');" onclick="displayCalendar(this,\'mm/dd/yyyy\',this);" readonly="readonly" value="" name="params[payment_plan]['+this.parts+']">';
        element += '</div>';
        $j('#payment_plan_div').append(element);
    },
    removePlan: function() {
        if (this.parts > 1) {
            $j('.payment_plan_'+this.parts).remove();
            this.parts--;
        }
    },
  
    onTypeSwitch: function(value) {
        if (value == '%') {
            this.activeDollarType = 0;
        } else if (value == '$') {
            this.activeDollarType = 1;
        }
        $j('.payment_plan_type').text(value);
        this.switchPlanType();
    },
  
    switchPlanType: function() {
        for (var i = 1; i <= this.parts; i++) {
            $j('#params-payment_plan_percent-' + i).attr('name', this.getPlanInputName(i));
        }
    },
  
    getPlanInputName: function(part) {
        var inputName = 'params[' + this.percentageName + '][' + part + ']';
  
        if (this.activeDollarType == 1) {
            inputName = 'params[' + this.dollarName + '][' + part + ']';
        }
  
        return inputName;
    },
  
    getPlanTypeLabel: function() {
        var label = '%';
  
        if (this.activeDollarType == 1) {
            label = '$';
        }
  
        return label;
    }
  }  
}